import { Heading, Box, Center, Text, useColorModeValue } from "@chakra-ui/react"

export interface ProjectCardI {
  title: string
  description: string
}

export const ProjectCard = (props: ProjectCardI) => {
  const { title, description } = props

  return (
    <Box
      maxW={"280px"}
      bg={useColorModeValue("white", "gray.900")}
      boxShadow={"2xl"}
      rounded={"lg"}
      p={6}
      mb={6}
      textAlign={"center"}
    >
      <Heading fontSize={"2xl"} fontFamily={"body"}>
        {title}
      </Heading>

      <Text
        textAlign={"center"}
        color={useColorModeValue("gray.700", "gray.400")}
        px={3}
      >
        {description}
      </Text>
    </Box>
  )
}
